import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarehouseFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 17.1211C22 17.8846 21.6837 18.6167 21.1211 19.1566C20.5585 19.6965 19.7956 20 19 20H18V7C18 6.44772 17.5523 6 17 6H5C4.44772 6 4 6.44772 4 7V20H3C2.20435 20 1.44152 19.6965 0.878906 19.1566C0.316346 18.6167 0 17.8846 0 17.1211V5.93731L0.00878906 5.72364C0.0496183 5.22522 0.225848 4.74446 0.520508 4.32918C0.857055 3.85498 1.33338 3.48739 1.88867 3.2749L9.88867 0.204831L9.88965 0.203894L10.1611 0.114866C10.709 -0.0382887 11.291 -0.0382887 11.8389 0.114866L12.1104 0.203894L12.1113 0.204831L20.1113 3.2749C20.667 3.48734 21.1428 3.85474 21.4795 4.32918C21.8161 4.80353 21.9975 5.36342 22 5.93731V17.1211Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 16H16V18H6V16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12H16V14H6V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 8H16V10H6V8Z",
			fill: "currentColor"
		})
	]
});
export default SvgWarehouseFilled;
